import { setToLocalStorage } from 'lib/utils/set-to-local-storage';
import { getFromLocalStorage } from 'lib/utils/get-from-local-storage';

// Persists UTM parameters (first-touch + last-touch) to localStorage for
// attribution. Shared by components/misc/analytics.tsx (normal pages) and the
// /lp/* lander runtime (lib/lp/lander-runtime.ts), so both capture UTMs the
// same way.
export const storeUtmParameters = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const normalizedParams: Record<string, string> = {};

  for (const [key, value] of urlParams.entries()) {
    normalizedParams[key.toLowerCase()] = value;
  }

  const utmCampaign = normalizedParams['utm_campaign'];
  const utmSource = normalizedParams['utm_source'];
  const utmMedium = normalizedParams['utm_medium'];
  const utmTerm = normalizedParams['utm_term'];
  const utmContent = normalizedParams['utm_content'];
  const utmId = normalizedParams['utm_id'];

  if (utmCampaign) {
    if (getFromLocalStorage('utm_campaign_first') === null) {
      setToLocalStorage('utm_campaign_first', utmCampaign);
    }
    setToLocalStorage('utm_campaign_last', utmCampaign);
  }
  if (utmSource) {
    if (getFromLocalStorage('utm_source_first') === null) {
      setToLocalStorage('utm_source_first', utmSource);
    }
    setToLocalStorage('utm_source_last', utmSource);
  }
  if (utmMedium) {
    if (getFromLocalStorage('utm_medium_first') === null) {
      setToLocalStorage('utm_medium_first', utmMedium);
    }
    setToLocalStorage('utm_medium_last', utmMedium);
  }
  if (utmTerm) {
    if (getFromLocalStorage('utm_term_first') === null) {
      setToLocalStorage('utm_term_first', utmTerm);
    }
    setToLocalStorage('utm_term_last', utmTerm);
  }
  if (utmContent) {
    if (getFromLocalStorage('utm_content_first') === null) {
      setToLocalStorage('utm_content_first', utmContent);
    }
    setToLocalStorage('utm_content_last', utmContent);
  }

  if (utmId && getFromLocalStorage('utm_id_first') === null) {
    setToLocalStorage('utm_id_first', utmId);
  }
  // The ID identifies the campaign, so a new campaign without one clears the
  // previous ID rather than leaving it attached to the wrong campaign name.
  if (utmCampaign || utmId) {
    setToLocalStorage('utm_id_last', utmId);
  }
};
